// src/core/composables/useInfoApi.ts
import { ref } from "vue";
import { infoService } from "@/core/services/info.service";
import type { ReleaseNotes, Version } from "@/models";
import { createApiComposable } from "@/core/composables/createApiComposable";
import { useAlerts } from "@/shared/composables/useAlerts";

export function useInfoApi() {
  const version = ref<Version>({} as Version);
  const releaseNotes = ref<ReleaseNotes[]>([]);

  const { errorToast } = useAlerts();

  const api = createApiComposable({
    errorToast,
    defaultErrorMessage: "Request failed",
  });

  const fetchVersion = async () => {
    const data = await api.run(() => infoService.fetchVersion(), "Failed to load version");
    version.value = data;
    return data;
  };

  const fetchReleaseNotes = async () => {
    const data = await api.run(
      () => infoService.fetchReleaseNotes(),
      "Failed to load release notes"
    );
    releaseNotes.value = data;
    return data;
  };

  return {
    version,
    releaseNotes,

    // shared api state
    loading: api.loading,
    error: api.error,
    clearError: api.clearError,

    // actions
    fetchVersion,
    fetchReleaseNotes,
  };
}
